<template>
  <div id="app">
    <router-view />

    <FinderDialog
      v-if="rootDialogParams"
      :key="rootDialogKey"
      v-bind="rootDialogParams"
      :visible.sync="isRootDialogShow"
    />
  </div>
</template>

<script>
// import XDialog from '@/finder/comps/dialog'
import { mapState, mapMutations } from 'vuex'
export default {
  // components: {
  //   XDialog
  // },
  data () {
    return {
      isRootDialogShow: false,
      rootDialogKey: '',
      rootDialogParams: null
    }
  },
  computed: {
    ...mapState({
      hasHeader: (state) => state.menu.hasHeader
    })
  },
  mounted () {},
  methods: {
    showRootDialog (params) {
      const key = Math.random()
      this.rootDialogKey = key
      this.rootDialogParams = params
      this.isRootDialogShow = true
    },
    handleTabClick (tab) {
      const { name } = tab
      if (name === 'sale') {
        this.setGlobalMenuType('sale')
      } else if (name === 'wechat') {
        this.setGlobalMenuType('wechat')
      }
    },
    ...mapMutations(['setGlobalMenuType'])
  }
}
</script>

<style lang="scss"></style>
